import { Text } from "@chakra-ui/react"
import BlankSlate from "@pathwright/ui/src/components/blank/BlankSlate"
import Link from "@pathwright/ux/src/components/link/Link"
import { useTranslate } from "@pathwright/ux/src/components/lng/useTranslate"
import Pathicon from "@pathwright/ux/src/components/pathicon/Pathicon"
import { useRouteMatch } from "react-router-dom"
import { useDiscussionContext } from "../DiscussionProvider"

const tPrefix = "discussion.responses"

function DiscussionSingleResponse() {
  const { t } = useTranslate()
  const response = useDiscussionContext((c) => c.response)
  const responses = useDiscussionContext((c) => c.responses)
  const responseId = useDiscussionContext((c) => c.responseId)
  const responseDeleted = useDiscussionContext((c) => c.responseDeleted)
  const viewAllResponses = useDiscussionContext((c) => c.viewAllResponses)

  // Match against the response ID route to determine if we should use a relativeTo link
  // for navigating back to all responses.
  const responseIdRouteMatch = useRouteMatch<{
    discussionId: string
    responseId?: string
  }>({
    path: "*/:response(response)/:responseId(\\d+)/",
    exact: true,
    strict: false
  })

  // Slightly improved check for showing "single response" message,
  // where we only show once the root response is loaded.
  const responseLoaded = responses?.[0]?.id === responseId

  return (response && responseLoaded) || responseDeleted ? (
    <>
      <Text py={2}>
        {t(`${tPrefix}.viewing_single`)}.{" "}
        <Link
          variant="underline"
          relativeTo={responseIdRouteMatch ? "../../" : undefined}
          onClick={viewAllResponses}
        >
          {t(`${tPrefix}.view_all`)}
          <Pathicon icon="arrow-right" />
        </Link>
      </Text>
      {responseDeleted && (
        <BlankSlate
          icons={null}
          heading={t(`${tPrefix}.doesnt_exist`)}
          body={t(`${tPrefix}.deleted`)}
        />
      )}
    </>
  ) : null
}

export default DiscussionSingleResponse
